module.exports = __webpack_public_path__ + "static/media/Sprint_ProductSetup.52048246.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/Sprint_ProductSetup.jpg
// module id = 3766
// module chunks = 0